import CandidateFormPage from './CandidateFormPage';

export default CandidateFormPage;